import { render, staticRenderFns } from "./MarketDefinitionForm.vue?vue&type=template&id=280a177f"
import script from "./MarketDefinitionForm.vue?vue&type=script&lang=js"
export * from "./MarketDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./MarketDefinitionForm.vue?vue&type=style&index=0&id=280a177f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports